switch(process.env.APP_ENV){
  case 'development':
    module.exports = {
      APM_ENDPOINT: "http://localhost:8200",
      BACKEND_API_ENDPOINT: "http://localhost:9000",
      ARCHIVE_API_ENDPOINT: "http://localhost:3009",
      PRIVATE_STORAGE_API: "http://localhost:9008",
    }
    break;
  case 'test':
    module.exports = {
      APM_ENDPOINT: 'https://apm.chatbee.io',
      BACKEND_API_ENDPOINT: "https://chat-backend-api.chatbee.io",
      ARCHIVE_API_ENDPOINT: "https://history-api.chatbee.io",
      PRIVATE_STORAGE_API: "https://private-storage-api.chatbee.io",
    }
    break;
  case 'production':
    module.exports = {
      APM_ENDPOINT: 'https://apm.chatbee.com.br',
      BACKEND_API_ENDPOINT: "https://chat-backend-api.chatbee.com.br",
      ARCHIVE_API_ENDPOINT: "https://history-api.chatbee.com.br",
      PRIVATE_STORAGE_API: "https://private-storage-api.chatbee.com.br",
    }
    break;
}